/* eslint-disable no-param-reassign,default-case,no-undef,no-return-assign,consistent-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message, Modal } from "antd";
import uniqBy from "lodash/uniqBy";
import sortBy from "lodash/sortBy";
import moment from "moment";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import {
  getChargesRoute,
  getChargesDetailsRoute,
  deleteAdjustmentRoute,
  createUpdateAdjustmentRoute,
  postChargesMassRoute,
  postChargeRoute,
  getChargesRouteV2,
  postChargesBulkRoute,
} from "../../lib/routes/charging";
import { buildQueryString } from "../../lib/utils";
import { getRoute } from "../../lib/routes";
import { toHttpFormat } from "../../lib/utils/formatDate";
import Message from "../../components/Message/Message";
import { recreateFinancialDocuments } from "../../lib/routes/processes";

const date = moment();
const nowDateParse = toHttpFormat(date);

const initialState = {
  charges: "",
  chargesLoading: rtkRequestStatusCodes.idle,
  chargesMass: "",
  chargesMassLoading: rtkRequestStatusCodes.idle,
  chargesDetails: "",
  chargesDetailsLoading: rtkRequestStatusCodes.idle,
  serviceForAdjustmentCreate: undefined,
  serviceForAdjustmentCreateLoading: rtkRequestStatusCodes.idle,
  createUpdateAdjustmentLoading: rtkRequestStatusCodes.idle,
  postChargesMassCreateLoading: rtkRequestStatusCodes.idle,
  postChargesBulkCreateLoading: rtkRequestStatusCodes.idle,
  checkedChargesNull: true,
};

const fetchChargesByAggId = createAsyncThunk(
  "charges/fetchChargesByAggId",
  async (chargeSearchParams) => {
    try {
      const url = getChargesRouteV2(chargeSearchParams);
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки начислений. Попробуйте позже", e);
    }
  }
);

const fetchChargesMass = createAsyncThunk("charges/fetchCharges", async (chargeSearchParams) => {
  try {
    const url = getChargesRoute(chargeSearchParams);
    const { data } = await axios(url);
    return data;
  } catch (e) {
    Message("Ошибка загрузки начислений. Попробуйте позже", e);
  }
});

const fetchChargesDetails = createAsyncThunk(
  "payments/fetchChargesDetails",
  async ({ chargeId }) => {
    const { data } = await axios.get(getChargesDetailsRoute("charges", "search", `${chargeId}`));
    return data;
  }
);

const deleteAdjustment = createAsyncThunk("charges/deleteAdjustment", async ({ queryString }) => {
  // const url = deleteAdjustmentRoute({ queryString });
  const url = [deleteAdjustmentRoute(), queryString].join("&");
  message.loading("Удаление корректировки", 0);
  try {
    await axios.delete(url);
    message.destroy();
    message.success("Корректировка удалена");
  } catch (e) {
    message.destroy();
    message.error({ content: "Ошибка удаления корректировки" });
  }
});

const createCharge = createAsyncThunk("charges/createCharge", async (params) => {
  const url = postChargeRoute();
  message.loading("Создание начисления", 0);
  return axios
    .post(url, params)
    .then(() => {
      message.destroy();
      message.success("Начисление создано");
    })
    .catch(() => {
      message.destroy();
      message.error({ content: "Ошибка создания начисления" });
    });
});

const createUpdateAdjustment = createAsyncThunk(
  "charges/createUpdateAdjustment",
  async ({ agreementId, adjustmentTypeId, queryString }) => {
    const url = [createUpdateAdjustmentRoute(agreementId, adjustmentTypeId), queryString].join("&");
    message.loading("Создание корректировки", 0);
    try {
      await axios.post(url);
      message.destroy();
      message.success("Корректировка создана");
    } catch (e) {
      message.destroy();
      message.error({ content: "Ошибка создания корректировки" });
    }
  }
);

const recreateFinancialDocumentsPatch = createAsyncThunk(
  "charges/recreateFinancialDocumentsPatch",
  async (dataPost) => {
    // message.loading("Создание корректировки", 0);
    try {
      await axios.post(recreateFinancialDocuments(), dataPost);
      // message.destroy();
      // message.success("Корректировка создана");
    } catch (e) {
      message.destroy();
      message.error({ content: "Ошибка создания корректировки" });
    }
  }
);

const fetchServiceByAggIdForChargeDetails = createAsyncThunk(
  "service/fetchServicesByAggId",
  async ({ agreements, ...queryParams }) => {
    // eslint-disable-next-line no-unused-expressions
    const queryString = buildQueryString({
      agreementId: agreements,
      includeFutureDates: false,
      onDate: nowDateParse,
      ...queryParams,
    });
    const url = getRoute("services-api", "services", `search?${queryString}`);
    const response = axios.get(url);
    const { data } = await response;
    return data;
    // const sortedArr = sortBy(dataServices, (o) => o.fromDate);
    // return sortedArr;
    // return uniqBy(sortedArr, "id");
  }
);

const postChargesMassCreate = createAsyncThunk(
  "charges/postChargesMassCreate",
  // eslint-disable-next-line no-shadow,consistent-return
  async (date) => {
    try {
      message.loading("Создание начислений...", 0);
      const response = axios.post(postChargesMassRoute(date));
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Начисления созданы", status);
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка создания начислений", e.response?.data?.message);
    }
  }
);

export const postChargesBulkCreate = createAsyncThunk(
  "charges/postChargesBulkCreate",
  // eslint-disable-next-line no-shadow,consistent-return
  async (params) => {
    try {
      message.loading("Создание начислений...", 0);
      const response = axios.post(postChargesBulkRoute(params));
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Начисления созданы", status);
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка создания начислений", e.response?.data?.message);
    }
  }
);

const fetchServiceByAggIdForAdjustmentCreate = createAsyncThunk(
  "service/fetchServiceByAggIdForAdjustmentCreate",
  async ({ agreementsIds, includePastDates = false, ...queryParams }) => {
    try {
      let dataServices = [];
      await Promise.all(
        agreementsIds.map(async (agreementId) => {
          const queryString = buildQueryString({
            agreementId,
            includeFutureDates: false,
            includePastDates,
            ...queryParams,
          });
          const url = getRoute("services-api", "services", `search?${queryString}`);
          const response = axios.get(url);
          const { data } = await response;
          if (response.length !== 0) {
            dataServices = [...dataServices, ...data];
          }
        })
      );
      const sortedArr = sortBy(dataServices, (o) => o.fromDate);
      return uniqBy(sortedArr, "id");
    } catch (e) {
      Message("Ошибка загрузки продуктов. Попробуйте позже", e);
    }
  }
);

const deleteCharges = createAsyncThunk(
  "billing/deleteCharges",
  ({ agreementId, periodFrom, periodTo, deleteMode }) => {
    const url = getRoute("billing-api", "charges");
    axios
      .delete(url, {
        data: {
          agreementId,
          periodFrom,
          periodTo,
          deleteMode,
        },
      })
      .then((response) => {
        if (Array.isArray(response.data)) {
          if (response.data.length !== 0) {
            const transactionIds = [];
            response.data.forEach(({ transactionId }) => {
              transactionIds.push(transactionId);
            });
            Modal.warning({
              title: "Задание завершено успешно",
              content: `Начисления ${transactionIds.join(", ")} недоступны для удаления.`,
            });
          } else {
            Modal.success({
              title: "Задание завершено успешно",
            });
          }
        }
      })
      .catch(({ response }) => {
        Modal.error({
          title: response.data,
        });
      });
  }
);

const slice = createSlice({
  name: "charges",
  initialState,
  reducers: {
    handleCheckUrlForRemovingChargeSessionStorage: {
      reducer: (state, { payload }) => {
        if (payload.url.includes("main-menu")) {
          sessionStorage.removeItem("chargeFilters");
        }
      },
    },
    clearCharges: {
      reducer: (state) => {
        state.charges = "";
        state.chargesLoading = rtkRequestStatusCodes.idle;
      },
    },
    clearMassCharges: {
      reducer: (state) => {
        state.chargesMass = "";
        state.chargesMassLoading = rtkRequestStatusCodes.idle;
      },
    },
    handleCheckedChargesNull: {
      reducer: (state, { payload }) => {
        state.checkedChargesNull = payload;
      },
    },
    clearServiceForAdjustmentCreate: {
      reducer: (state) => {
        state.serviceForAdjustmentCreateLoading = rtkRequestStatusCodes.rejected;
        state.serviceForAdjustmentCreate = undefined;
      },
    },
  },
  extraReducers: {
    [fetchChargesByAggId.fulfilled]: (state, { payload }) => {
      state.charges = payload;
      state.chargesLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchChargesByAggId.pending]: (state) => {
      state.chargesLoading = rtkRequestStatusCodes.pending;
    },
    [fetchChargesByAggId.rejected]: (state) => {
      state.chargesLoading = rtkRequestStatusCodes.rejected;
    },
    [postChargesMassCreate.pending]: (state) => {
      state.postChargesMassCreateLoading = rtkRequestStatusCodes.pending;
    },
    [postChargesMassCreate.fulfilled]: (state) => {
      state.postChargesMassCreateLoading = rtkRequestStatusCodes.fulfilled;
    },
    [postChargesMassCreate.rejected]: (state) => {
      state.postChargesMassCreateLoading = rtkRequestStatusCodes.rejected;
    },
    [postChargesBulkCreate.pending]: (state) => {
      state.postChargesBulkCreateLoading = rtkRequestStatusCodes.pending;
    },
    [postChargesBulkCreate.fulfilled]: (state) => {
      state.postChargesBulkCreateLoading = rtkRequestStatusCodes.fulfilled;
    },
    [postChargesBulkCreate.rejected]: (state) => {
      state.postChargesBulkCreateLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchChargesMass.fulfilled]: (state, { payload }) => {
      state.chargesMass = payload;
      state.chargesMassLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchChargesMass.pending]: (state) => {
      state.chargesMassLoading = rtkRequestStatusCodes.pending;
    },
    [fetchChargesMass.rejected]: (state) => {
      state.chargesMassLoading = rtkRequestStatusCodes.rejected;
    },

    [fetchChargesDetails.fulfilled]: (state, { payload }) => {
      state.chargesDetails = payload;
      state.chargesDetailsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchChargesDetails.pending]: (state) => {
      state.chargesDetailsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchChargesDetails.rejected]: (state) => {
      state.chargesDetailsLoading = rtkRequestStatusCodes.rejected;
    },

    [fetchServiceByAggIdForAdjustmentCreate.fulfilled]: (state, action) => {
      state.serviceForAdjustmentCreate = action.payload;
      state.serviceForAdjustmentCreateLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceByAggIdForAdjustmentCreate.pending]: (state) => {
      state.serviceForAdjustmentCreateLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceByAggIdForAdjustmentCreate.rejected]: (state) => {
      state.serviceForAdjustmentCreateLoading = rtkRequestStatusCodes.rejected;
      state.serviceForAdjustmentCreate = undefined;
    },

    [createUpdateAdjustment.fulfilled]: (state) => {
      state.createUpdateAdjustmentLoading = rtkRequestStatusCodes.fulfilled;
    },
    [createUpdateAdjustment.pending]: (state) => {
      state.createUpdateAdjustmentLoading = rtkRequestStatusCodes.pending;
    },
    [createUpdateAdjustment.rejected]: (state) => {
      state.createUpdateAdjustmentLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { actions, reducer } = slice;

const {
  handleCheckUrlForRemovingChargeSessionStorage,
  clearCharges,
  clearMassCharges,
  handleCheckedChargesNull,
  clearServiceForAdjustmentCreate,
} = actions;

export {
  actions,
  clearCharges,
  clearMassCharges,
  fetchChargesByAggId,
  fetchChargesMass,
  fetchChargesDetails,
  createUpdateAdjustment,
  deleteAdjustment,
  fetchServiceByAggIdForChargeDetails,
  postChargesMassCreate,
  handleCheckUrlForRemovingChargeSessionStorage,
  fetchServiceByAggIdForAdjustmentCreate,
  recreateFinancialDocumentsPatch,
  deleteCharges,
  createCharge,
  handleCheckedChargesNull,
  clearServiceForAdjustmentCreate,
};

export default reducer;
